export default {
  name: 'MessageCard',
  props: {
    card: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    normalizedCard: function normalizedCard() {
      return {
        type: this.card.type || this.card.cardType || 'card',
        title: this.card.title || '系统通知',
        summary: this.card.summary || '',
        status: this.card.status || '',
        deepLink: this.card.deepLink || ''
      };
    },
    tagText: function tagText() {
      if (this.normalizedCard.type === 'todo') {
        return '待处理';
      }
      if (this.normalizedCard.status) {
        return this.normalizedCard.status;
      }
      return '';
    }
  }
};